module.exports = __webpack_public_path__ + "assets/img/32_1444_big.194a1970.jpg";